/**
 * Сборка сведений, которые поддержка спрашивает первым делом.
 *
 * Логика вынесена из разметки намеренно (см. Development Principles в CLAUDE.md):
 * в JSX остаётся только отрисовка, а состав полей и формат отчёта проверяются тестами.
 */

/** Пустой `REACT_APP_BACKEND_URL` — это не «не настроено», а рабочий режим same-origin. */
export const describeBackend = (backendUrl) => {
  const trimmed = typeof backendUrl === 'string' ? backendUrl.trim() : '';

  return trimmed === ''
    ? 'Тот же домен (/api через nginx)'
    : trimmed.replace(/\/$/, '');
};

export const describeApiStatus = (status) => {
  switch (status) {
    case 'ok':
      return 'Доступен';
    case 'error':
      return 'Недоступен';
    default:
      return 'Проверяется…';
  }
};

/**
 * Порядок полей — это порядок вопросов поддержки: сначала кто и где, потом что со связью.
 * Пустые значения не выбрасываются, а показываются прочерком: «поля нет» и «поле пустое» —
 * разные симптомы, и склеивать их в отчёте значит терять половину диагноза.
 */
export const buildSupportDetails = ({ tenantId, backendUrl, version, username, apiStatus } = {}) => [
  { key: 'tenant', label: 'Тенант', value: tenantId || '—' },
  { key: 'user', label: 'Учётная запись', value: username || '—' },
  { key: 'backend', label: 'Адрес бекенда', value: describeBackend(backendUrl) },
  { key: 'api', label: 'Связь с API', value: describeApiStatus(apiStatus) },
  { key: 'version', label: 'Версия интерфейса', value: version || '—' }
];

/** Текст для буфера обмена: одна строка на поле, чтобы это можно было вставить в письмо. */
export const formatSupportReport = (details) =>
  (Array.isArray(details) ? details : [])
    .map(({ label, value }) => `${label}: ${value}`)
    .join('\n');
